import api from "api";

const statistics = {
    summary:      (slug, params) =>
        api().get(`/establishments/${slug}/statistics/sales-summary`, { params }),
    revenueByHour:(slug, params) =>
        api().get(`/establishments/${slug}/statistics/revenue-by-hour`, { params }),
    topProducts:  (slug, params) =>
        api().get(`/establishments/${slug}/statistics/top-products`, { params }),
};

export default statistics;
